import cx from 'classnames';
import style from './Swatch.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const Swatch = ({ color }) => {
  return (
    <div className={style.swatch}>
      <span className={cx(style.color, style[color])} />
    </div>
  );
};

export default Swatch;
